import { useCallback } from "react";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";
import { urlReplacer } from "../../../utils";

export default function () {
  const { request } = useApi();
  return {
    fetchAll: useCallback(async () => {
      return request({
        method: "GET",
        url: `${ApiRoutes.MAJORS}`,
      });
    }, [request]),
    fetchAllForCloneProgram: useCallback(
      async (programId) => {
        return request({
          method: "GET",
          url: urlReplacer(ApiRoutes.GET_MAJORS_FOR_PROGRAM_CLONE, {
            programId,
          }),
        });
      },
      [request],
    ),
    fetchContainingPrograms: useCallback(
      async (schoolId) => {
        return request({
          method: "GET",
          url: `${ApiRoutes.MAJORS}?contains-programs${
            schoolId ? `&schoolId=${schoolId}` : ""
          }`,
        });
      },
      [request],
    ),

    fetchOne: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_MAJOR, {
            id,
          })}`,
        });
      },
      [request],
    ),

    fetchCreate: useCallback(
      async (data) => {
        return request({
          data,
          method: "POST",
          url: ApiRoutes.CREATE_MAJOR,
        });
      },
      [request],
    ),

    fetchUpdate: useCallback(
      async ({ id, ...data }) => {
        return request({
          data,
          method: "PUT",
          url: urlReplacer(ApiRoutes.UPDATE_MAJOR, {
            id,
          }),
        });
      },
      [request],
    ),

    fetchDelete: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_MAJOR, { id })}`,
        });
      },
      [request],
    ),
  };
}
